import { render, staticRenderFns } from "./DocumentosVisualizacao.vue?vue&type=template&id=0ad93173&scoped=true"
import script from "./DocumentosVisualizacao.vue?vue&type=script&lang=js"
export * from "./DocumentosVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad93173",
  null
  
)

export default component.exports